module.exports = __webpack_public_path__ + "static/media/logout-gray.46823442.svg";